import React from 'react';
import OlcButton from '~/components/General/OlcButton';

// MUI Components
import { Box, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { NoTrackingCIcon } from '~/assets/images';
import { TRACKING_PHONE_NUMBER_LEARN_URL } from '~/utils/constants';

// Styles
import './styles.scss';

const NoTrackingScreen = ({ addNewTracking }) => {
  return (
    <Box className="noTrackingScreenWrapper">
      <Box className="noTrackingScreenCard">
        <Box className="noTrackingScreenHeader">
          <Typography variant="h2">Tracking Phone Numbers</Typography>
          <OlcButton variant="primary" startIcon={<AddIcon />} onClick={addNewTracking}>
            Activate Tracking Number
          </OlcButton>
        </Box>
        <Box className="noTrackingScreen">
          <img src={NoTrackingCIcon} alt="No Tracking" />
          <Typography variant="h4">No Tracking Phone Numbers Active</Typography>
          <Typography variant="h6">
            Tracking phone numbers forward calls to your number while capturing data in the
            platform, so you can track engagement and see results in analytics.
          </Typography>
          <a href={TRACKING_PHONE_NUMBER_LEARN_URL} target="_blank" rel="noopener noreferrer">
            Learn more
          </a>
          <Typography>
            Each additional call tracking number beyond your plan’s limit will add $5 to your
            monthly subscription.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default NoTrackingScreen;
